import React, { useState, useEffect } from "react";

import "../css/bootstrap.min.css";
import "../css/style.css";
import "../css/Navbar.css";
import "../css/committeeofboard.css";
function Committeeofboard() {
  const [directors, setDirectors] = useState([]);
  const [selectedDirector, setSelectedDirector] = useState(null);

  useEffect(() => {
    const fetchDirectors = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/committee/board-of-Committees`
        );
        const data = await response.json();
        console.log(data);
        if (response.ok) {
          setDirectors(data.data);
        } else {
          console.error("Failed to fetch directors:", data.message);
        }
      } catch (error) {
        console.error("Error fetching directors:", error);
      }
    };

    fetchDirectors();
  }, []);

  const openPopup = (director) => {
    setSelectedDirector(director);
    document.getElementById("popup-overlay").style.display = "block";
  };

  const closePopup = () => {
    setSelectedDirector(null);
    document.getElementById("popup-overlay").style.display = "none";
  };

  const groupedDirectors = directors.reduce((acc, director) => {
    const category = director.committeecategory;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(director);
    return acc;
  }, {});

  const getCategoryTitle = (category) => {
    switch (category) {
      case "audit committee":
        return "Audit Committee";
      case "nomination and remuneration committee":
        return "Nomination and Remuneration Committee";
      case "stakeholder relationship committee":
        return "Stakeholder Relationship Committee";
      default:
        return category;
    }
  };

  return (
    <>
      <div className="banner-committee">
        <div className="banner-content-committee">
          <h3 className="h3-committee">Welcome to Our Committee</h3>
          <p className="P-committee">Its demo Content</p>
        </div>
      </div>

      <br />
      <br />

      {/*<div className="content-director">
        <h3 className="director-heading">Meet Our Leadership Team</h3>
        <p>
          It's demo content introducing the dedicated leadership team behind our organization.
        </p>
      </div>*/}

      {Object.entries(groupedDirectors).map(([category, directors]) => (
        <div key={category} className="committee-section">
          <h3 className="committee-category">{getCategoryTitle(category)}</h3>
          <div className="board-of-directors">
            {directors.map((director, index) => (
              <div
                className="director"
                key={director.id || index}
                onClick={() => openPopup(director)}
              >
                <img
                  src={director.image} 
                  
                  alt={`Director ${director.name}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "placeholder.png";
                  }}
                />
                <br />
                <br />
                <div className="director-name">{director.name}</div>
                <p>{director.designation}</p>
                <div className="plus-sign">+</div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {selectedDirector && (
        <div
          id="popup-overlay"
          className="popup-overlay"
          style={{ display: "block" }}
        >
          <div className="popup-content">
            <button
              className="close-popup"
              onClick={closePopup}
              aria-label="Close popup"
            >
              ×
            </button>
            {selectedDirector && (
              <img
                src={`${selectedDirector.image}${
                  selectedDirector.image || "placeholder.png"
                }`}
                alt={`Director ${directors.name}`}
              />
            )}

            <div className="popup-description">
              <h2 id="popup-name">{selectedDirector.name}</h2>
              <p id="popup-bio">{selectedDirector.designation}</p>
              <p>{selectedDirector.profileSummary}</p>
            </div>
          </div>
        </div>
      )}

      <br />
      <br />
    </>
  );
}

export default Committeeofboard;
